var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9499 39.092C69.9499 56.5119 55.8283 70.6335 38.4084 70.6335C20.9885 70.6335 6.86688 56.5119 6.86688 39.092C6.86688 21.6721 20.9885 7.55047 38.4084 7.55047C55.8283 7.55047 69.9499 21.6721 69.9499 39.092ZM76.5902 39.092C76.5902 60.1792 59.4956 77.2738 38.4084 77.2738C17.3211 77.2738 0.226562 60.1792 0.226562 39.092C0.226562 18.0047 17.3211 0.910156 38.4084 0.910156C59.4956 0.910156 76.5902 18.0047 76.5902 39.092ZM56.4143 29.516C57.5943 28.4268 57.5943 26.5207 56.4143 25.4315C55.3251 24.2515 53.419 24.2515 52.3298 25.4315L31.181 46.5803L21.5597 37.0497C20.4705 35.8697 18.5644 35.8697 17.4752 37.0497C16.2952 38.1389 16.2952 40.045 17.4752 41.1342L29.0934 52.7524C30.1826 53.9324 32.0887 53.9324 33.1779 52.7524L56.4143 29.516Z",
    fill: "#40C706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularGreenCheck);
export default __webpack_public_path__ + "static/media/circular-green-check.cec47e17e40a579beb8b7e6f22c353a8.svg";
export { ForwardRef as ReactComponent };